(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2032,5442],{

/***/ 59848:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.Z = undefined;

var _classCallCheck2 = __webpack_require__(99663);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(22600);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(49135);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(93196);

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Container, _React$Component);

  function Container() {
    (0, _classCallCheck3.default)(this, Container);
    return (0, _possibleConstructorReturn3.default)(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  (0, _createClass3.default)(Container, [{
    key: 'getClassName',
    value: function getClassName() {
      var className = ['os_container'];
      className.push('os_container_' + this.props.size);
      if (this.props.className) {
        className.push(this.props.className);
      }

      return className.join(' ');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.getClassName(), style: this.props.style },
        this.props.children
      );
    }
  }]);
  return Container;
}(_react2.default.Component), _class.propTypes = {
  children: _propTypes2.default.any,
  style: _propTypes2.default.object,
  size: _propTypes2.default.string,
  className: _propTypes2.default.string
}, _class.defaultProps = {
  size: 'big',
  style: {},
  className: ''
}, _temp);
exports.Z = Container;

/***/ }),

/***/ 94184:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 97874:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[mobileOrDesktop]/[hostname]/info-legal",
      function () {
        return __webpack_require__(86827);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79961);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);




function Loading(props) {
    var color = props.color, className = props.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().item), className),
            style: {
                borderColor: color
            }
        })
    });
};


/***/ }),

/***/ 19060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SsgFallback; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69528);
/* harmony import */ var _packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59848);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80805);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_4__);





function SsgFallback() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_packages_justo_parts_lib_components_Container__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().container),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_4___default().loading)
        })
    });
};


/***/ }),

/***/ 25442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NoWebsite; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43469);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_2__);



function NoWebsite(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().container),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/images/no-website.svg",
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().image)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().title),
                children: "Este sitio web no est\xe1 configurado correctamente"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: "https://getjusto.com",
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_2___default().logo),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/logo-dark.svg"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 86827:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ InfoLegalPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/SsgFallback/index.tsx
var SsgFallback = __webpack_require__(19060);
// EXTERNAL MODULE: ./src/page-components/Layout/index.tsx + 33 modules
var Layout = __webpack_require__(97246);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.esm.js
var react_select_esm = __webpack_require__(23157);
// EXTERNAL MODULE: ./src/helpers/misc/isServerSide.ts
var isServerSide = __webpack_require__(90257);
// EXTERNAL MODULE: ./node_modules/@packages/apollo-hooks/lib/index.js
var lib = __webpack_require__(25074);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var graphql_tag_lib = __webpack_require__(50456);
// EXTERNAL MODULE: ./src/page-components/LegalInformation/styles.module.css
var styles_module = __webpack_require__(1551);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/page-components/LegalInformation/LocalLegalInformation.tsx



var LocalLegalInformation = function(param) {
    var legalInformationToView = param.legalInformationToView, companyName = param.companyName, imageURL = param.imageURL;
    var name = legalInformationToView.name, rut = legalInformationToView.rut, legalRepName = legalInformationToView.legalRepName, legalRepRut = legalInformationToView.legalRepRut, address = legalInformationToView.address, phone = legalInformationToView.phone, email = legalInformationToView.email;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: imageURL,
                        alt: "Logo",
                        width: "26",
                        className: (styles_module_default()).logoLocal
                    }),
                    companyName
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: "Informaci\xf3n legal"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).blockLegalInformation,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).leftColumn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Nombre raz\xf3n social"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Rut"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Nombre Representante Legal"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Rut Representante Legal"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Direcci\xf3n"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Tel\xe9fono"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Correo Electronico"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).rightColumn,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: rut
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: legalRepName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: legalRepRut
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: address
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: phone
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: email
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/page-components/LegalInformation/index.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query GetTradeNames($websiteId: ID) {\n        getTradeNames(websiteId: $websiteId) {\n          _id\n          name\n          rut\n          address\n          phone\n          email\n          legalRepName\n          legalRepRut\n          storeIds\n        }\n        stores(websiteId: $websiteId) {\n          items {\n            _id\n            name\n          }\n        }\n        website(websiteId: $websiteId) {\n          _id\n          name\n          logo {\n            _id\n            url: resizedURL(height: 200)\n          }\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}








function LegalInformation(props) {
    var ref2;
    var websiteId = props.website._id;
    var ref1 = (0,react.useState)(null), legalInformationToView = ref1[0], setLegalInformationToView = ref1[1];
    var data = (0,lib.useApolloQuery)({
        query: (0,graphql_tag_lib["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        omit: (0,isServerSide/* default */.Z)(),
        partial: true
    }).data;
    var legalInformation = data.getTradeNames, stores = data.stores, website = data.website;
    var getLocals = function() {
        return stores === null || stores === void 0 ? void 0 : stores.items.map(function(store) {
            return {
                value: store._id,
                label: store.name
            };
        });
    };
    var handleLegalData = function(e) {
        if (e) {
            var ref = _slicedToArray(legalInformation.filter(function(legal) {
                return legal.storeIds.includes(e.value);
            }), 1), legalDataForLocal = ref[0];
            if (legalDataForLocal) {
                var address = legalDataForLocal.address, email = legalDataForLocal.email, legalRepName = legalDataForLocal.legalRepName, legalRepRut = legalDataForLocal.legalRepRut, name = legalDataForLocal.name, phone = legalDataForLocal.phone, rut = legalDataForLocal.rut;
                setLegalInformationToView({
                    address: address,
                    email: email,
                    legalRepName: legalRepName,
                    legalRepRut: legalRepRut,
                    name: name,
                    phone: phone,
                    rut: rut
                });
            } else {
                setLegalInformationToView(null);
            }
        } else {
            setLegalInformationToView(null);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).container,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: "Identificaci\xf3n de Locales"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).content,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Selecciona un Local"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_select_esm["default"], {
                        options: getLocals(),
                        onChange: handleLegalData
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    legalInformationToView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalLegalInformation, {
                        companyName: website.name,
                        imageURL: (ref2 = website.logo) === null || ref2 === void 0 ? void 0 : ref2.url,
                        legalInformationToView: legalInformationToView
                    }) : null
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/NoWebsite/index.tsx
var NoWebsite = __webpack_require__(25442);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/pages/_sites/[mobileOrDesktop]/[hostname]/info-legal/index.tsx






var __N_SSG = true;
function InfoLegalPage(props) {
    var router = (0,next_router.useRouter)();
    if (router.isFallback) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(SsgFallback/* default */.Z, {});
    }
    if (!props.website) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(NoWebsite["default"], {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        initialData: props.initialData,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LegalInformation, {
            website: props.website
        })
    });
};


/***/ }),

/***/ 79961:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"_1fDaNhCtjd-FpXakwh9Uf3","newOrionLoading":"_16XzDHOt3VBY5SGGpiZ3ZT"};

/***/ }),

/***/ 80805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_2k40sP--bs7-ORleL6riGA","loading":"_2eozYEUmcZzMsjXiI6UIu6"};

/***/ }),

/***/ 1551:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_1TLTiIJdCtGB4_3C-OK0_2","content":"_2RCbeKRQJnkLBUQxxVXBwu","blockLegalInformation":"a1DdndglX3NHUPyPCJQxP","leftColumn":"_2BwSk-auBZzKsiDMLko9Fk","rightColumn":"_3iZXQZ8W81HjdbeAh2TGeC","logoLocal":"_1JKQr0x8VZUq01KFxdNM4g"};

/***/ }),

/***/ 43469:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3uvgfwBWaWQqFyLab9Dtip","image":"hS9SabcUKdHLsU7xUWYeA","title":"_3zsZZ1G9oclG4rKZNszc97","logo":"_1EDR5Wb9Y0TBlQji0Ya33U"};

/***/ }),

/***/ 23157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NonceProvider": function() { return /* binding */ NonceProvider; },
/* harmony export */   "components": function() { return /* reexport safe */ _index_c7a4d7ce_esm_js__WEBPACK_IMPORTED_MODULE_3__.c; },
/* harmony export */   "createFilter": function() { return /* reexport safe */ _Select_126cf1dd_esm_js__WEBPACK_IMPORTED_MODULE_2__.c; },
/* harmony export */   "defaultTheme": function() { return /* reexport safe */ _Select_126cf1dd_esm_js__WEBPACK_IMPORTED_MODULE_2__.d; },
/* harmony export */   "mergeStyles": function() { return /* reexport safe */ _Select_126cf1dd_esm_js__WEBPACK_IMPORTED_MODULE_2__.m; },
/* harmony export */   "useStateManager": function() { return /* reexport safe */ _useStateManager_783b07d5_esm_js__WEBPACK_IMPORTED_MODULE_0__.u; }
/* harmony export */ });
/* harmony import */ var _useStateManager_783b07d5_esm_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94310);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Select_126cf1dd_esm_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7521);
/* harmony import */ var _babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15671);
/* harmony import */ var _babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43144);
/* harmony import */ var _babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60136);
/* harmony import */ var _index_c7a4d7ce_esm_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99949);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54880);
/* harmony import */ var _emotion_cache__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68357);
/* harmony import */ var memoize_one__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(30845);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73935);























var StateManagedSelect = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (props, ref) {
  var baseSelectProps = (0,_useStateManager_783b07d5_esm_js__WEBPACK_IMPORTED_MODULE_0__.u)(props);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_Select_126cf1dd_esm_js__WEBPACK_IMPORTED_MODULE_2__.S, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    ref: ref
  }, baseSelectProps));
});

var NonceProvider = /*#__PURE__*/function (_Component) {
  (0,_babel_runtime_helpers_esm_inherits__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(NonceProvider, _Component);

  var _super = (0,_index_c7a4d7ce_esm_js__WEBPACK_IMPORTED_MODULE_3__._)(NonceProvider);

  function NonceProvider(props) {
    var _this;

    (0,_babel_runtime_helpers_esm_classCallCheck__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, NonceProvider);

    _this = _super.call(this, props);

    _this.createEmotionCache = function (nonce, key) {
      return (0,_emotion_cache__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        nonce: nonce,
        key: key
      });
    };

    _this.createEmotionCache = (0,memoize_one__WEBPACK_IMPORTED_MODULE_9__["default"])(_this.createEmotionCache);
    return _this;
  }

  (0,_babel_runtime_helpers_esm_createClass__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(NonceProvider, [{
    key: "render",
    value: function render() {
      var emotionCache = this.createEmotionCache(this.props.nonce, this.props.cacheKey);
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement(_emotion_react__WEBPACK_IMPORTED_MODULE_11__.C, {
        value: emotionCache
      }, this.props.children);
    }
  }]);

  return NonceProvider;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);

/* harmony default export */ __webpack_exports__["default"] = (StateManagedSelect);



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1470,9727,1796,4356,3477,7502,7246,9774,2888,179], function() { return __webpack_exec__(97874); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);